import Vue from "vue";
import VueRouter from "vue-router";
// import LoginPage from '@/Pages/LoginPage/index.vue';
import Caixas from "@/Pages/Caixas/index.vue";
import LoginPage from "@/Pages/LoginPage/index.vue";
import LogoutPage from "@/Pages/LogoutPage.vue";
import ResetPasswordPage from "@/Pages/LoginPage/ResetPasswordPage.vue";
import HomePage from "@/Pages/HomePage/index.vue";
import AdminPage from "@/Pages/AdminPage/index.vue";
import ListarUsuariosPage from "@/Pages/AdminPage/Usuarios/ListarUsuariosPage.vue";

import redirecionarSeForProfessor from "./guards/redirecionarSeForProfessor";
import redirecionarSeForProfAuxiliar from "./guards/redirecionarSeForProfAuxiliar";
import redirecionarSeForResponsavel from "./guards/redirecionarSeForResponsavel";
import redirecionarSeForPontofiq from "./guards/redirecionarSeForPontofiq";

import salaDeSituacao from "./salaDeSituacao";

import authService from "../Services/AuthService";
import mensalidades from "./mensalidades";
import franquias from "./franquias";
import turmas from "./turmas";
import series from "./series";
import disciplinas from "./disciplinas";
import alunos from "./alunos";
import professores from "./professores";
import matriculas from "./matriculas";
import usuarios from "./usuarios";
import inep from "./inep";
import gestaoDeAulas from "./gestaoDeAulas";
import gestaoDeAulasAEE from "./gestaoDeAulasAEE";
import gestaoDeAulasAuxiliares from "./gestaoDeAulasAuxiliares";
import aulas from "./aulas";
import acessoProfessor from "./acessoProfessor";
import acessoResponsavel from "./acessoResponsavel";
import notas from "./notas";
import relatorios from "./relatorios";
import educacaoInclusiva from "./educacaoInclusiva";
import avisos from "./avisos";
import agendas from "./agendas";
import planos from "./planos";
import notifiq from "./notifiq";
import historico from "./historico";
import bolsaFamilia from "./bolsa-familia";
import NaoAutorizado from "../Pages/NaoAutorizado.vue";
import fundeb from "./fundeb";
import instrutores from "./instrutores";
import usabilidadeProfessor from "./usabilidadeProfessor";
import colaboradores from "./colaboradores";
import buscaAtiva from "./buscaAtiva";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "login" },
    title: "Início",
  },
  {
    path: "/login",
    name: "login",
    title: "Login",
    component: LoginPage,
    beforeEnter(target, from, next) {
      if (authService.isLoggedIn()) {
        return next({ name: "home" });
      }
      return next();
    },
  },
  {
    path: "/home",
    name: "home",
    title: "Início",
    component: HomePage,
    beforeEnter: async (to, from, next) => {
      await redirecionarSeForResponsavel(to, from, next);
      await redirecionarSeForProfessor(to, from, next);
      await redirecionarSeForProfAuxiliar(to, from, next);
      await redirecionarSeForPontofiq(to, from, next);
      return next();
    },
  },
  {
    path: "/reset-password",
    name: "resetPassword",
    component: ResetPasswordPage,
    beforeEnter(target, from, next) {
      if (authService.isLoggedIn()) {
        return next({ name: "home" });
      }
      return next();
    },
  },
  {
    path: "/caixas",
    name: "caixas",
    title: "Caixas",
    component: Caixas,
  },
  {
    path: "/admin",
    name: "admin",
    title: "Admin",
    component: AdminPage,
    beforeEnter(to, from, next) {
      return next({ name: "home" });
    },
  },
  {
    path: "/admin/usuarios/listar",
    name: "admin.usuarios.listar",
    title: "Listar Usuários Admin",
    component: ListarUsuariosPage,
    beforeEnter(to, from, next) {
      return next({ name: "home" });
    },
  },
  {
    path: "/logout",
    name: "logout",
    title: "Logout",
    component: LogoutPage,
  },
  {
    path: "/nao-autorizado",
    name: "NaoAutorizado",
    component: NaoAutorizado,
  },
  ...mensalidades,
  ...franquias,
  ...turmas,
  ...series,
  ...disciplinas,
  ...alunos,
  ...professores,
  ...matriculas,
  ...usuarios,
  ...inep,
  ...gestaoDeAulas,
  ...gestaoDeAulasAEE,
  ...gestaoDeAulasAuxiliares,
  ...aulas,
  ...salaDeSituacao,
  ...acessoProfessor,
  ...acessoResponsavel,
  ...notas,
  ...relatorios,
  ...educacaoInclusiva,
  ...avisos,
  ...agendas,
  ...notifiq,
  ...planos,
  ...historico,
  ...bolsaFamilia,
  ...fundeb,
  ...instrutores,
  ...usabilidadeProfessor,
  ...colaboradores,
  ...buscaAtiva,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve((to, from, next) => {
  if (to.title) document.title = `${to.title} - ${process.env.VUE_APP_PAGE_TITLE}`;
  next();
});

router.beforeEach((to, from, next) => {
  if (to.name !== "resetPassword" && to.name !== "login" && !authService.isLoggedIn())
    next({
      name: "login",
      query: {
        redirect: to.fullPath,
        name: to.name,
      },
    });
  else next();
});

export default router;
